function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3838 9C16.3838 11.2091 14.5929 13 12.3838 13C10.1747 13 8.38379 11.2091 8.38379 9C8.38379 6.79086 10.1747 5 12.3838 5C14.5929 5 16.3838 6.79086 16.3838 9ZM14.3838 9C14.3838 10.1046 13.4884 11 12.3838 11C11.2792 11 10.3838 10.1046 10.3838 9C10.3838 7.89543 11.2792 7 12.3838 7C13.4884 7 14.3838 7.89543 14.3838 9Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3838 1C6.30866 1 1.38379 5.92487 1.38379 12C1.38379 18.0751 6.30866 23 12.3838 23C18.4589 23 23.3838 18.0751 23.3838 12C23.3838 5.92487 18.4589 1 12.3838 1ZM3.38379 12C3.38379 14.0902 4.09633 16.014 5.29177 17.5417C6.93624 15.3889 9.53006 14 12.4483 14C15.3286 14 17.8929 15.3531 19.5403 17.4583C20.6968 15.9443 21.3838 14.0524 21.3838 12C21.3838 7.02944 17.3544 3 12.3838 3C7.41323 3 3.38379 7.02944 3.38379 12ZM12.3838 21C10.2336 21 8.25944 20.2459 6.71146 18.9878C7.97731 17.1812 10.0748 16 12.4483 16C14.7922 16 16.8671 17.1521 18.1376 18.9209C16.5777 20.2191 14.5719 21 12.3838 21Z",
  fill: "#4979C0"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.26ee1290.svg";
export { ForwardRef as ReactComponent };